import React from "react";
import { Button, Card } from "react-bootstrap";
import APIComponent from "../components/API";
import {
  Block,
  KTLink,
  Label,
  InfoAlertHelper,
  InfoTooltip,
} from "../components/Base";
import { PRIMARY_COLOR, DANGER_COLOR } from "../constants";
import { generatePickupPhLink } from "../helpers";
import core from "../vendors/core-api/";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ServiceChargeForm from "./forms/ServiceChargeForm";
// import ThemeColorsForm from "./forms/ThemeColorsForm";

const MySwal = withReactContent(Swal);

export default class CurbsideSettingsDiv extends React.Component {
  constructor(props) {
    super(props);
    this.api = core("pu").get();
    this.state = {
      isActive: this.props.store.isCurbsideActive ? true : false,
      store: this.props.store ? this.props.store : "",
    };
  }

  componentDidUpdate() {
    // console.log("component did update state: ", this.state)
  }

  handleToggleCurbsideStatus = (isChecked) => {
    let values = {};
    // console.log("props: ", this.props)
    // console.log("state: ", this.state)
    // console.log("isChecked: ", isChecked)
    const { isActive, store } = this.state;
    isChecked = !isChecked;
    this.setState({ isActive: isChecked });
    store.isCurbsideActive = isChecked;
    this.setState({ store });
    // console.log("state: ", this.state)
    // console.log("isCurbsideActive: ", store.isCurbsideActive)

    values["store_id"] = store._id;
    values["isActive"] = store.isCurbsideActive;
    this.api
      .put({
        url: "/store/allow-curbside-pickup",
        data: values,
      })
      .then(({ data }) => {
        if (data.result === "ok") {
          MySwal.fire({
            icon: "success",
            title: "Success!",
            text: "You have successfully saved your changes.",
            confirmButtonColor: PRIMARY_COLOR,
            confirmButtonText: "Ok",
            // timer: 1000
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const { isActive, store } = this.state;
    return (
      <>
        <Card className="card-custom gutter-b">
          <Card.Header>
            <Card.Title>Curbside Pickup Settings</Card.Title>
          </Card.Header>
          <Card.Body>
            <div>
              <InfoAlertHelper
                text={
                  "You can manage your curbside pickup service availability in your Curbside Pickup Settings"
                }
              />
              <Block
                content={
                  <>
                    <Card className="d-flex justify-content-between w-100">
                      <Card.Body>
                        <div
                          style={{ transform: "scale(1.2)" }}
                          className="row d-flex align-items-center"
                        >
                          <span className="switch switch-outline switch-icon switch-primary py-1 m-0 ml-10 pl-10">
                            <label>
                              <input
                                type="checkbox"
                                name="isActive"
                                checked={isActive ? "checked" : null}
                                // disabled={store.name? "" : "disabled"}
                                onChange={() =>
                                  this.handleToggleCurbsideStatus(isActive)
                                }
                              />
                              <span></span>
                            </label>
                          </span>
                          <label className="text-dark font-weight-boldest text-uppercase py-4 px-3">
                            Allow Curbside Pickup Orders
                          </label>
                          {InfoTooltip(
                            "Turning this off will remove the curbside pickup option for your customers.",
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                    <ServiceChargeForm
                      store={store}
                      order_type={"curbside_pickup"}
                    />
                  </>
                }
              ></Block>
            </div>
          </Card.Body>
        </Card>
      </>
    );
  }
}
